import { AxiosResponse } from 'axios';

import { ClientService } from '@/types/api';
import { ApprovementDTO } from '@/features/approvements/dtos/approvement.dto';
import { GetApprovementsListResponse } from '@/api/approvements/response';
import {
    RespondToApprovalRequest,
    AssignApproverRequest,
    GetApprovementsListRequest,
    RevokeApprovalRequest
} from '@/api/approvements/request';

export class ApprovementsApi {
    private prefix = 'v2/approvements';

    constructor(private readonly clientService: ClientService) {
        this.clientService = clientService;
    }

    public async assignApprover(data: AssignApproverRequest): Promise<AxiosResponse<boolean>> {
        return this.clientService.post(`${this.prefix}/assign`, data);
    }

    public async getProjectApprovals(projectId: number, { filters, ...params }: GetApprovementsListRequest, briefMode?: boolean): Promise<AxiosResponse<GetApprovementsListResponse>> {
        return this.clientService.post(`${this.prefix}/project-history/${projectId}`, filters, {
            params: {
                ...params,
                briefMode
            },
        });
    }

    public async revokeApproverAssignment(approvementId: number, data: RevokeApprovalRequest): Promise<AxiosResponse<boolean>> {
        return this.clientService.post(`${this.prefix}/${approvementId}/revoke`, data);
    }

    public async respondToApproval(approvementId: number, data: RespondToApprovalRequest): Promise<AxiosResponse<boolean>> {
        return this.clientService.post(`${this.prefix}/${approvementId}/respond`, data);
    }

    public async getUserApprovals(isMe: boolean, userId: number, { filters, ...params }: GetApprovementsListRequest): Promise<AxiosResponse<GetApprovementsListResponse>> {
        return this.clientService.post(`${this.prefix}/${isMe ? 'my' : `user/${userId}`}`, filters, {
            params,
        });
    }
}
